import { useState, useEffect } from "react"
import { useUpdateTaskMutation, useDeleteTaskMutation } from "./tasksApiSlice"
import { Outlet, useNavigate, useParams } from "react-router-dom"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowAltCircleRight, faCopy, faSave, faTrashCan } from "@fortawesome/free-solid-svg-icons"
import useAuth from "../../hooks/useAuth"
import ActionsListAddEdit from '../actions/ActionsListAddEdit'
import TimeLeft from '../../partial/TimeLeft'
import Uploader from "../../partial/Uploader"
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css'; // import the styles
import GradeStepsMain from "../grade-steps/GradeStepsMain"

const EditTaskForm = ({ task, groups }) => {

    const { isTeacher, isAdmin } = useAuth()
    const {groupId, type} = useParams()
    const [updateTask, {
        isLoading,
        isSuccess,
        isError,
        error
    }] = useUpdateTaskMutation()

    const [deleteTask, {
        isSuccess: isDelSuccess,
        isError: isDelError,
        error: delerror
    }] = useDeleteTaskMutation()

    const navigate = useNavigate()

    const [title, setTitle] = useState(task.title)
    const [body, setBody] = useState(task.body)
    const [group, setGroup] = useState(task.group)
    const [active, setActive] = useState(task.active)
    const [incluedInGrade, setIncluedInGrade] = useState(task.incluedInGrade)
    const [defaultCheckInclueRelatedFriends, setDefaultCheckInclueRelatedFriends] = useState(task.defaultCheckInclueRelatedFriends)
    const [order, setOrder] = useState(task.order)
    const [ratio, setRatio] = useState(task.ratio)
    const [fromDate, setFromDate] = useState(new Date(task.fromDate))
    const [toDate, setToDate] = useState(new Date(task.toDate))
    const [img, setImg] = useState(task.img)
    const [gradeSteps, setGradeSteps] = useState(task.gradeSteps || [])



    useEffect(() => {

        if (isSuccess || isDelSuccess) {
            setTitle('')
            setBody('')
            setGroup('')
            setActive(true)
            setOrder(0)
            setRatio(0)
            navigate(`/${type}/${groupId}/tasks`)
        }

    }, [isSuccess, isDelSuccess, navigate])

  
    const canSave = [title, body, group, fromDate, toDate].every(Boolean) && !isLoading

    const onSaveTaskClicked = async (e) => {
        if (canSave) {
             const savedGradesSteps = gradeSteps.map(step => {
                return {
                    ...step,
                    _id: step._id.length > 20? step._id : undefined
                }
            })  

            await updateTask({ id: task.id, group, title, body, active, fromDate, toDate, img, ratio, order, incluedInGrade ,defaultCheckInclueRelatedFriends , gradeSteps: savedGradesSteps })
        }
    }

    const onDeleteTaskClicked = async () => {
        await deleteTask({ id: task.id })
    }

    const created = new Date(task.createdAt).toLocaleString('en-US', { day: 'numeric', month: 'long', year: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' })
    const updated = new Date(task.updatedAt).toLocaleString('en-US', { day: 'numeric', month: 'long', year: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' })

    const options = groups.map(group => {
        return (
            <option
                key={group.id}
                value={group.id}
            > {group.name}</option >
        )
    })


    const errClass = (isError || isDelError) ? "errmsg" : "offscreen"
 
    const errContent = (error?.data?.message || delerror?.data?.message) ?? ''


    let deleteButton = null
    if (isTeacher || isAdmin) {
        deleteButton = (
            <button
                className="icon-button"
                title="Delete"
                onClick={onDeleteTaskClicked}
            >
                <FontAwesomeIcon icon={faTrashCan} />
            </button>
        )
    }

    const content = (
        <>
            <p className={errClass}>{errContent}</p>

            <form className="form" onSubmit={e => e.preventDefault()}>
                <div className="form__title-row">
                    <h2>Edit Task</h2>
                    <div className="form__action-buttons">
                    <button
                            className="icon-button"
                            title="Back to Task"
                            onClick={()=>{navigate(`/${type}/${groupId}/tasks`)}}
                        >
                            <FontAwesomeIcon icon={faArrowAltCircleRight} />
                        </button>
                        {/* <button
                            className="icon-button"
                            title="Duplicate"
                            onClick={()=>{navigate(`/${type}/${groupId}/tasks/${task.id}/new`)}}
                           
                        >
                            <FontAwesomeIcon icon={faCopy} />
                        </button> */}
                        <button
                            className="icon-button"
                            title="Duplicate"
                            onClick={()=>{navigate(`/${type}/${groupId}/tasks/${task.id}/duplicate`)}}
                           
                        >
                            <FontAwesomeIcon icon={faCopy} />
                        </button>
                        <button
                            className="icon-button"
                            title="Save"
                            onClick={onSaveTaskClicked}
                            disabled={!canSave}
                        >
                            <FontAwesomeIcon icon={faSave} />
                        </button>
                        {deleteButton}
                    </div>
                </div>
                <div className="form-input-container">

                <label className="form__label" htmlFor="title">
                    Title:</label>
                <input
                    className={`form__input  ${!title &&'form__input--incomplete'}`}
                    id="title"
                    name="title"
                    type="text"
                    autoComplete="off"
                    value={title}
                    onChange={(e)=>setTitle(e.target.value)}
                />
                </div>
                <div className="form-input-container">

                <label className="form__label" htmlFor="body">
                    Body:</label>
                    <ReactQuill
                    value={body}
                    onChange={setBody}
                    modules={{
                        toolbar: [
                          [{ 'header': '1'}, {'header': '2'}, {'font': []}],
                         // [{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }],
                          [{ 'align': [] }],
                          [{ 'direction': 'rtl' }],   
                          [{size: []}],
                          [{ color: [] }, { background: [] }],
                          ['bold', 'italic', 'underline', 'strike', 'blockquote'],
                          [{'list': 'ordered'}, {'list': 'bullet'}/*,       {'indent': '-1'}, {'indent': '+1'}*/],
                          ['link'],
                          ['clean']
                        ],
                        clipboard: {
                          matchVisual: false,
                        }
                      }}
                    />
                {/* <textarea
                    className={`form__input form__input--text ${!body &&'form__input--incomplete'}`}
                    id="body"
                    name="body"
                    value={body}
                    onChange={(e)=>setBody(e.target.value)}
                /> */}
                </div>
                <Uploader label={'Img'} folderId={'MANAGE_TASKS'} file={img} setFile={setImg} isImg={true} />

                <div className="form-flex">

                <div className="form-input-container">
                 <label className="form__label" htmlFor="fromDate">
                    From Date:</label>
                    <input
                    className={`form__input  ${!fromDate &&'form__input--incomplete'}`}
                    id="fromDate"
                    name="fromDate"
                    type="datetime-local"
                    autoComplete="off"
                    value= {`${fromDate.getFullYear().toString()}-${(fromDate.getMonth() + 1).toString().padStart(2, 0)}-${fromDate.getDate().toString().padStart(2, 0)}T${fromDate.getHours().toString().padStart(2, 0)}:${fromDate.getMinutes().toString().padStart(2, 0)}`}
                    onChange={(e)=>setFromDate(new Date(e.target.value))}
                />
                </div>
                 <div className="form-input-container">
                 <label className="form__label form__title-row" htmlFor="toDate">
                   <span> To Date:</span> <small > (<TimeLeft endtime={toDate} />)</small> </label>
                <input
                    className={`form__input  ${!toDate &&'form__input--incomplete'}`}
                    id="toDate"
                    name="toDate"
                    type="datetime-local"
                    autoComplete="off"
                    value= {`${toDate.getFullYear().toString()}-${(toDate.getMonth() + 1).toString().padStart(2, 0)}-${toDate.getDate().toString().padStart(2, 0)}T${toDate.getHours().toString().padStart(2, 0)}:${toDate.getMinutes().toString().padStart(2, 0)}`}
                    onChange={(e)=>setToDate(new Date(e.target.value))}
                />
                </div>
                </div>
                <div className="form-flex">
                <div className="form-input-container">
                <label className="form__label form__checkbox-container" htmlFor="group">
                    GROUP:</label>
                <select
                    disabled
                    readOnly
                    id="group"
                    name="group"
                    className={`form__input  ${!group &&'form__input--incomplete'}`}
                    value={group}
                    onChange={(e)=>setGroup(e.target.value)}
                >
                    {options}
                </select>
                    </div>
                    <div className="form-input-container">
                  <label className="form__label" htmlFor="action-order">
                    Order:</label>
                <input
                    className={`form__input `}
                    id="action-order"
                    name="order"
                    type="number"
                    autoComplete="off"
                    value={order}
                    onChange={(e)=>setOrder(e.target.value)}
                />
                </div>
                <div className="form-input-container">
                  <label className="form__label" htmlFor="action-ratio">
                  Ratio:</label>
                <input
                    className={`form__input `}
                    id="action-ratio"
                    name="ratio"
                    type="number"
                    autoComplete="off"
                    value={ratio}
                    onChange={(e)=>setRatio(e.target.value)}
                />
                </div>
                   
                    
                      

                </div>
                <div className="form-input-container">
                    <div className="form__divider">
                    <label className="form__label form__checkbox-container" htmlFor="user-include-in-grade">
                    Inclued In Grade:
                    <input
                        className="form__checkbox"
                        id="user-include-in-grade"
                        name="user-include-in-grade"
                        type="checkbox"
                        checked={incluedInGrade}
                        onChange={(e)=>setIncluedInGrade(prev => !prev)}
                    />
                </label>
               
                    </div>
                
                </div>
                <div className="form-input-container">
                    <div className="form__divider">
                    <label className="form__label form__checkbox-container" htmlFor="user-relatedFriend">
                  סימון ציון גם לחברות בברירת מחדל
                    <input
                        className="form__checkbox"
                        id="user-relatedFriend"
                        name="user-relatedFriend"
                        type="checkbox"
                        checked={defaultCheckInclueRelatedFriends}
                        onChange={(e)=>setDefaultCheckInclueRelatedFriends(prev => !prev)}
                    />
                </label>
               
                    </div>
                
                </div>

 <div className="form-input-container">
                    <GradeStepsMain gradeSteps={gradeSteps} setGradeSteps={setGradeSteps} />
                </div>

                <div className="form-input-container">
                    <div className="form__divider">
                    <label className="form__label form__checkbox-container" htmlFor="user-active">
                    ACTIVE:
                    <input
                        className="form__checkbox"
                        id="user-active"
                        name="user-active"
                        type="checkbox"
                        checked={active}
                        onChange={(e)=>setActive(prev => !prev)}
                    />
                </label>
               
                    </div>
                
                </div>
                <ActionsListAddEdit />
            </form>
           
            <div className="form__divider">
                        <p className="form__created">Created:<br />{created}</p>
                        <p className="form__updated">Updated:<br />{updated}</p>
            </div>
            <Outlet />
        </>
    )

    return content
}

export default EditTaskForm